export const ORDER_ON_BEHALF = 'order-on-behalf-banner';
export const ORDER_ON_BEHALF_DIALOG = 'order-on-behalf-dialog';
export const ORDER_FORM_ROOT = 'order-form-root';
export const ORDER_ON_BEHALF_DIALOG_BACK_ARROW = 'order-on-behalf-dialog-back-arrow';
export const ORDER_ON_BEHALF_DIALOG_CHANGE_CONSULTANT_INPUT = 'order-on-behalf-dialog-change-consultant-input';
